jQuery(document).ready(function() {
    
    const $ = jQuery;
    const margin = 200;

    //  $('.left-site-bar').height($( document ).height());
    
function validLinks(that) {
    let { eventLink, iscars , isevents, isnews, ispartners, isprice, isracers } = $(that).data();

    let linksMenu = { 
        'calendar': isevents, 
        'cars': iscars, 
        'racers': isracers, 
        'news': isnews, 
        'partners': ispartners, 
        'prices': isprice};


    // let linksMenu = { 
    //     'calendar': true, 
    //     'cars': true, 
    //     'racers': true, 
    //     'news': true, 
    //     'partners': true, 
    //     'prices': true};

        if (!linksMenu.calendar, !linksMenu.cars, !linksMenu.racers, !linksMenu.news, !linksMenu.partners, !linksMenu.prices) {
            $('.left-site-bar__line').css('opacity', 0);
        }


        $('.left-menu__ul').removeClass('hide');
        Object.keys(linksMenu).forEach((link) => {
        $(`.left-${link}`).attr('href', `${eventLink}#${link}`)
       if (!linksMenu[link]) $(`.left-${link}`).parent().addClass('hide');
    })

}

    $('.left-site-bar__single-event').hover(function() {
        
        let imgData = $(this).children('img').data();
        validLinks(this);
        // put href on left menu links
        $('.left-site-bar__line').css('top', $(this).position().top);
        $(this).children('img').attr('src', imgData.colorImg);
        
      
        
        $('.left-menu').css('top', $(this).position().top + 200);
        $('.left-menu').addClass('left-menu--visible');
        $('.left-menu').removeClass('left-menu--closing');

        
        }, function(){
            let imgData = $(this).children('img').data();
            $('.left-menu').addClass('left-menu--closing');
            $('.left-menu').removeClass('left-menu--visible');
            $(this).children('img').attr('src', imgData.greyImg);
    });    
    


    // CLOSE THE SITEBARS
    $('.close-side-bar').on('click', function() {
        let dataProp = Object.keys($(this).data())[0];
        $(this).children('img').toggleClass('rotate');
        $(this).data()[dataProp] = !$(this).data()[dataProp];
        $(this).attr(`data-${dataProp}`, $(this).data()[dataProp]);
        
        if ($(`.${ dataProp }-site-bar`).hasClass(dataProp)) {
            $(`.${ dataProp }-site-bar`).removeClass(dataProp);
            $(this).children('span').text($(this).children('span').data().textClose);
        } else {
            $(`.${ dataProp }-site-bar`).addClass(dataProp);
            $(this).children('span').text($(this).children('span').data().textOpen);
        }
    })


$('.left-site-bar-res__single-event').on('click', function () {
    if ($(`#${$(this).data().responsiveToggle}`).is(":visible")) $(this).addClass('active-res');
    else  $(this).removeClass('active-res');
    validLinks(this);
})
    }); 



